import * as React from "react";
const SvgCustomSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3.66675, y: 3.375, width: 6, height: 6, rx: 3, fill: "currentColor" }));
export default SvgCustomSquare;
